import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";


export class TaskServiceTimeQuickEditFieldComponent implements IController {
  serviceTime: number
  disableEditMode: boolean | undefined;
  onServiceTimeChanged: Function;

  public showEditButton: boolean = false;
  public isEditServiceTime: boolean = false;
  public serviceTimeInMinutes: number;

  constructor(private $filter, private $document) {
  }

  $onInit() {
    this.setServiceTimeInMinutes(this.serviceTime);
    const temp = angular.element(this.$document);
    temp.bind("keydown", (e) => {
      if (e.keyCode == 27) {
        this.showEditButton = false;
        this.isEditServiceTime = false;
        this.setServiceTimeInMinutes(this.serviceTime);
      }
    });
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.serviceTime && !changes.serviceTime.isFirstChange()) {
      this.showEditButton = false;
      this.isEditServiceTime = false;
      this.setServiceTimeInMinutes(this.serviceTime);
    }
  }

  setServiceTimeInMinutes(serviceTime: number) {
    if (!serviceTime) {
      this.serviceTimeInMinutes = 0;
    } else {
      this.serviceTimeInMinutes = serviceTime / 60000;
    }

  }

  onInputKeyPressed($event) {
    if (($event.type === "blur" || $event.which === 13)) { // 13 === enter key
      const initialServiceTimeInMinutes = this.serviceTime / 60000;

      if (this.serviceTimeInMinutes > 0 && this.serviceTimeInMinutes !== initialServiceTimeInMinutes) {
        const serviceTimeByMilli = this.serviceTimeInMinutes * 60000;
        this.showEditButton = false;
        this.isEditServiceTime = false;
        this.onServiceTimeChanged({serviceTime: serviceTimeByMilli})
      } else {
        this.showEditButton = false;
        this.isEditServiceTime = false;
        this.setServiceTimeInMinutes(this.serviceTime);
      }
    }
  }

  onEditServiceTimeInputInit() {
    document.getElementById("service-time-input").focus();
  }


}

angular
  .module('bringoz.admin.tasks')
  .component('taskServiceTimeQuickEditField', {
    bindings: {
      serviceTime: '<?',
      disableEditMode: '<?',
      onServiceTimeChanged: '&'
    },
    template: require('./task-service-time-quick-edit-field.html').default,
    controller: TaskServiceTimeQuickEditFieldComponent

  });
